import React from "react";
import {
  BooleanField,
  Button,
  FunctionField,
  ImageField,
  Labeled,
  ReferenceField,
  ShowProps,
  TextField,
} from "react-admin";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { GridinRowsWithSpace } from "utils/style";
import CustomDateField from "components/CustomDateField";
import { GetParam } from "utils/tools";
import EditIcon from "@material-ui/icons/Edit";
import StatusField from "../../components/StatusField";
import CustomBooleanField from "../../components/CustomBooleanField";

const useStyles = makeStyles({
  summaryButton: {
    position: "relative",
    top: 20,
    padding: "8px 16px",
  },
});

const Summary = (props: ShowProps) => {
  const param = GetParam();
  const classes = useStyles();

  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12} style={GridinRowsWithSpace}>
          <Typography variant="h6">Student Detail</Typography>
          <Button
            className={classes.summaryButton}
            onClick={() =>
              props.history.push(
                `/students/${props.id}${
                  param.get("parentId")
                    ? `?parentId=${param.get("parentId")}`
                    : ""
                }`
              )
            }
            label="Edit"
          >
            <EditIcon />
          </Button>
        </Grid>

        <Grid item xs={12} style={GridinRowsWithSpace}>
          <Grid item xs={3}>
            <ImageField classes={classes} source="photoUrl" />
          </Grid>
          <Grid item xs={9}>
            <Grid item xs={12}>
              <Labeled source="Id">
                <TextField source="id" emptyText="-" />
              </Labeled>
            </Grid>

            <Grid item xs={12}>
              <Labeled source="Name">
                <FunctionField
                  render={(record: any) =>
                    `${record.firstName} ${record.lastName}`
                  }
                />
              </Labeled>
            </Grid>

            <Grid item xs={12}>
              <Labeled source="Last 4 Characters + Alphabet">
                <TextField source="uniqueCode" emptyText="-" />
              </Labeled>
            </Grid>

            <Grid item xs={12}>
              <Labeled source="Status">
                <StatusField source="status" />
              </Labeled>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={3}>
          <Labeled source="Date of Birth">
            <CustomDateField source="dateOfBirth" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={3}>
          <Labeled source="Gender">
            <TextField source="gender" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <Labeled source="Created On">
            <CustomDateField source="createdAt" emptyText="-" isDateTime />
          </Labeled>
        </Grid>

        <Grid item xs={3}>
          <Labeled source="Updated On">
            <CustomDateField source="updatedAt" emptyText="-" isDateTime />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        {/* <Grid item xs={3}>
          <Labeled source="Start Date">
            <TextField source="startDate" emptyText="-" />
          </Labeled>
        </Grid>

        <Grid item xs={3}>
          <Labeled source="End Date">
            <TextField source="endDate" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <Labeled source="Major">
            <TextField source="createdOn" emptyText="-" />
          </Labeled>
        </Grid>

        <Grid item xs={3}>
          <Labeled source="Minor">
            <TextField source="updatedOn" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>
         */}

        <Grid item xs={12}>
          <Labeled source="Medical Condition">
            <TextField source="medicalCondition" emptyText="-" />
          </Labeled>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6">School Details</Typography>
        </Grid>

        <Grid item xs={6}>
          <Labeled source="School">
            <ReferenceField
              source="schoolId"
              reference="schools"
              emptyText="-"
              linkType={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={2}>
          <Labeled source="Level">
            <ReferenceField
              source="levelId"
              reference="levels"
              emptyText="-"
              linkType={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid item xs={2}>
          <Labeled source="Class">
            <ReferenceField
              source="levelGroupId"
              reference="levelGroups"
              emptyText="-"
              linkType={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={6}>
          <Labeled source="Mac Address">
            <TextField source="macAddress" emptyText="-" />
          </Labeled>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6">Parent Details</Typography>
        </Grid>

        <Grid item xs={6}>
          <Labeled source="Id">
            <TextField source="parent.id" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <Labeled source="Name">
            <ReferenceField
              source="parent.id"
              reference="parents"
              link="show"
              emptyText="-"
            >
              <FunctionField
                render={(record: any) =>
                  `${record.firstName} ${record.lastName}`
                }
              />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid item xs={3}>
          <Labeled source="Mobile">
            <TextField source="parent.mobile" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6">Drop Off Authorization</Typography>
        </Grid>
        <Grid item xs={6}>
          <Labeled source="Need guardian for Drop Off?">
            <CustomBooleanField
              source="dropOffAuth"
              textForTrueValue="Yes"
              textForFalseValue="No"
            />
          </Labeled>
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
